var React = require('react');

function ToolsIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"opacity":".504","fillRule":"evenodd","clipRule":"evenodd","d":"m33 26 3.056 3.055a8 8 0 0 1 8.742 9.742L42 36h-6v6l2.797 2.797a8 8 0 0 1-9.742-8.742L26 33l7-7zM11 3a8 8 0 0 1 7.945 8.945L22 15l-7 7-3.055-3.055A8 8 0 1 1 11 3zm0 3a5 5 0 1 0 0 10 5 5 0 0 0 0-10z","fill":"#006AFF","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M43.5 4.5a4.95 4.95 0 0 0-7 0L5 36l-2 9 9-2 31.5-31.5a4.95 4.95 0 0 0 0-7z","fill":"#006AFF","key":1})]);
}

ToolsIcon.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = ToolsIcon;

ToolsIcon.default = ToolsIcon;
